const smartFields = {
  "subscription.migration.confirmed": {
    customer: {
      email: "morty@mailinator.com",
      first_name: "Pusher",
      last_name: "Presser",
      uuid: "abcd",
    },
    customer_first_name: "Pusher",
    first_bill_date: "01/01/2025",
    first_bill_total: 100,
    from_plan_name: "The old plan",
    from_plan_period: "Monthly",
    member_details_link: "https://localhost",
    next_bill_date: "01/02/2025",
    paid_now: false,
    recurring_bill_value: "$100.00",
    switch_date: "01/02/2025",
    to_plan_name: "New plan",
    to_plan_period: "Weekly",
  },
  "subscription.member.reassigned": {
    cta_link: "https://localhost",
    cta_text: "View Member Information",
    member: {
      uuid: "usr_zyxw1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Harley",
      last_name: "Harrison",
    },
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    staff: {
      name: "Morgan Tesla",
      recipient: "morgan.marshall@grr.la",
      uuid: "staff_abc12345dfr",
    },
  },
  "billing.account.updated": {
    user: {
      uuid: " usr_abcd1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Morgan",
      last_name: "Marshall",
    },
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    customer: {
      uuid: "usr_zyxw1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Harley",
      last_name: "Harrison",
    },
    cta_link: " https://pushpress.com",
    cta_text: "Verify Your Bank Account",
  },
  "billing.ach.instant": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    customer: {
      uuid: "usr_zyxw1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Harley",
      last_name: "Harrison",
    },
    cta_link: " https://pushpress.com",
    cta_text: "Verify Your Bank Account",
  },
  "billing.ach.manual": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    customer: {
      uuid: "usr_zyxw1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Harley",
      last_name: "Harrison",
    },
    cta_link: " https://pushpress.com",
    cta_text: "Verify Your Bank Account",
  },
  "billing.payment.failed": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    customer: {
      uuid: "usr_zyxw1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Harley",
      last_name: "Harrison",
    },
    cta_link: " https://pushpress.com",
    cta_text: "Verify Your Bank Account",
    invoice_uuid: "inv_abcd1234",
    transaction: {
      amount: "$100.00",
      amount_outstanding: "$50.00",
      reason: "Cos you are broke",
    },
  },
  "billing.payment.succeeded": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    customer: {
      uuid: "usr_zyxw1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Harley",
      last_name: "Harrison",
    },
    cta_link: " https://pushpress.com",
    cta_text: "Verify Your Bank Account",
    subject: "Payment Succeeded",
    invoice: {
      total: "$100.00",
      payment_amount: "$90.00",
      amount_outstanding: "10.0",
    },
  },
  "billing.payment.refunded": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    customer: {
      uuid: "usr_zyxw1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Harley",
      last_name: "Harrison",
    },
    order: {
      receipt_id: "rec_abcd134555",
      amount: "$100.00",
      amount_refunded: "$99.99",
      refund_method: "Cash",
    },
  },
  "communication.email.inventory_warning_sent": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    product_option_name: "Strongman 400",
    product_name: "Protein Whey",
    inventory_count: 30,
  },
  "subscription.plan.canceled": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    customer: {
      uuid: "usr_zyxw1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Harley",
      last_name: "Harrison",
    },
    plan_name: "Gold Plan 2x Week",
    end_date: "28th July, 2021",
    cancel_reason: "Gym instructor is crazy",
  },
  "schedule.event.registration": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    customer: {
      uuid: "usr_zyxw1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Harley",
      last_name: "Harrison",
      phone: "+1 (555) 123-4567",
    },
    event_name: "Gold Plan 2x Week",
    amount: "50",
    cta_link: " https://pushpress.com",
  },
  "subscription.plan.completed": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    customer: {
      uuid: "usr_zyxw1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Harley",
      last_name: "Harrison",
    },
    subscription_name: "Gold Plan 2x Week",
    cta_link: " https://pushpress.com",
    cta_text: "Re-Join Now!",
  },
  "billing.payment.cash_reminder": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    customer: {
      uuid: "usr_zyxw1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Harley",
      last_name: "Harrison",
    },
    plan_name: "Gold Plan 2x Week",
    amount_due: "$100.00",
    due_date: "31st February, 20XX",
    business_license: "BUS_1234_XXX",
    strong_date: true,
    table_title: "Membership Payment Overdue",
  },
  "communication.email.profile_sent": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    cta_link: " https://pushpress.com",
    cta_text: "Setup Profile & Sign Now",
    documents: {},
    document_label: "Document Label",
    document_text: "<h3>Random Document Text</h3>",
  },
  "user.lead.created": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    customer: {
      uuid: "usr_zyxw1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Harley",
      last_name: "Harrison",
    },
  },
  "user.document.requested": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    document_count: 2,
    document_title: "Sample Doc Title",
    cta_link: " https://pushpress.com",
    cta_text: "Review and Sign Now",
    message: "Please take a moment to view and sign this document for us.",
  },
  "communication.migration.email_sent": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    customer: {
      uuid: "usr_zyxw1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Harley",
      last_name: "Harrison",
    },
    cta_link: " https://pushpress.com",
    cta_text: "Migrate Your Account",
  },
  "user.profile.updated": {
    customer: {
      uuid: "usr_zyxw1234567890",
      email: "morgan.marshall@grr.la",
      first_name: "Harley",
      last_name: "Harrison",
    },
    client: {
      company: "Test Gym",
      email: "testing@pushpress.com",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    message:
      "This email is to let you know that your email address has been changed. If this was not requested by you, or this was done in error, please let us know.  Thank you.",
  },
  "report.daily_summary.email_sent": {
    client: {
      company: "Gym",
      email: " customer.service@grr.la",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    cta_link: " https://pushpress.com",
    cta_text: "View Your Payments Report",
    start_timestamp: 1627450483,
    end_timestamp: 1627470483,
    report: {
      membership_fees: "$999.99",
      event_registrations: "Events1,2and3",
      appointments: "Afterwork Gym",
      product_sales: "$1045.75",
      total_sales: "$12500.75",
      refunds: "$0.00",
      net_sales: "$1200.00",
    },
    headline: "Daily Report",
  },
  "billing.payment.authorization_request": {
    user: {
      uuid: " usr_abcd1234567890",
      email: "maxi@mailinator.com",
      first_name: "Maxi",
      last_name: "PushPress",
    },
    client: {
      company: "JeremyFitness",
      email: "testing@pushpress.com",
      phone: "+1 (555) 123-4567",
      address: "742 Evergreen Terrace, Springfield",
    },
    invoice: {
      amount: "$125.99",
      uuid: "inv_abcd12345",
    },
    cta_link: " https://pushpress.com",
    cta_text: "Review and Authorize",
  },
};

export default smartFields;
